import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertType } from './alert-type';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/translate";
import * as i2 from "@angular/common";
export class AlertComponent {
    translateService;
    type = AlertType.Info;
    closable = true;
    smallAlert = false;
    suppressAnnouncement = false;
    // eslint-disable-next-line @angular-eslint/no-output-native
    close = new EventEmitter();
    boundKeyDownFunc = this.onKeyDown.bind(this);
    typeDict = {
        'alert-info': 'Important',
        'alert-success': 'Success',
        'alert-warning': 'Warning',
        'alert-error': 'Error',
    };
    constructor(translateService) {
        this.translateService = translateService;
    }
    alertClose() {
        window.removeEventListener('keydown', this.boundKeyDownFunc);
        this.close.emit();
    }
    onFocus() {
        window.addEventListener('keydown', this.boundKeyDownFunc);
    }
    onBlur() {
        window.removeEventListener('keydown', this.boundKeyDownFunc);
    }
    getAriaRole() {
        if (this.typeDict[this.type] === 'Error') {
            return 'alert';
        }
        else {
            return 'alert-dialog';
        }
    }
    getAlertType(type) {
        return this.translateService.translate('ngx-shared-' + this.typeDict[type].toLowerCase());
    }
    getIsClosable() {
        return this.type === AlertType.Error ? false : this.closable;
    }
    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.alertClose();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertComponent, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AlertComponent, selector: "mhe-alert", inputs: { type: "type", closable: "closable", smallAlert: "smallAlert", suppressAnnouncement: "suppressAnnouncement" }, outputs: { close: "close" }, ngImport: i0, template: "<div\n  class=\"alert\"\n  [class.alert-small]=\"smallAlert\"\n  [ngClass]=\"type\"\n  [attr.aria-live]=\"suppressAnnouncement ? 'off' : 'assertive'\"\n  [attr.role]=\"suppressAnnouncement ? null : 'alert'\"\n>\n  <span class=\"sr-only\">{{ getAlertType(type) | async }}</span>\n  <ng-content></ng-content>\n\n  <button\n    *ngIf=\"getIsClosable()\"\n    (click)=\"alertClose()\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    class=\"close\"\n    title=\"{{ 'ngx-shared-close-this-alert' | mheTranslate | async }}\"\n    type=\"button\"\n  >\n    <span aria-hidden=\"true\"><i class=\"dpg-icon dpg-icon-system-close\"></i></span>\n  </button>\n</div>\n", styles: ["\n"], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i2.AsyncPipe, "mheTranslate": i1.TranslatePipe } });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mhe-alert', template: "<div\n  class=\"alert\"\n  [class.alert-small]=\"smallAlert\"\n  [ngClass]=\"type\"\n  [attr.aria-live]=\"suppressAnnouncement ? 'off' : 'assertive'\"\n  [attr.role]=\"suppressAnnouncement ? null : 'alert'\"\n>\n  <span class=\"sr-only\">{{ getAlertType(type) | async }}</span>\n  <ng-content></ng-content>\n\n  <button\n    *ngIf=\"getIsClosable()\"\n    (click)=\"alertClose()\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    class=\"close\"\n    title=\"{{ 'ngx-shared-close-this-alert' | mheTranslate | async }}\"\n    type=\"button\"\n  >\n    <span aria-hidden=\"true\"><i class=\"dpg-icon dpg-icon-system-close\"></i></span>\n  </button>\n</div>\n", styles: ["/*# sourceMappingURL=alert.component.css.map */\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; }, propDecorators: { type: [{
                type: Input
            }], closable: [{
                type: Input
            }], smallAlert: [{
                type: Input
            }], suppressAnnouncement: [{
                type: Input
            }], close: [{
                type: Output
            }] } });
